import { useMemo } from 'react'

import { useLineChart } from './use-line-chart'

interface Props {
  title?: string
  tickFormatter?: (value: number) => string
}

export const LineChartYAxis: React.FC<Props> = ({ title, tickFormatter = (value) => value.toString() }) => {
  const { ticks, yScale, plotAreaWidth } = useLineChart()

  const ys = useMemo(() => {
    return ticks.map(yScale)
  }, [ticks, yScale])

  return (
    <g transform={`translate(${plotAreaWidth ? plotAreaWidth + 10 : 0}, 0)`}>
      {/* Title */}
      {!!title && (
        <text className="translate-y-0.5 select-none" x={0} y={12} fontSize="11" fill="#aaa">
          {title}
        </text>
      )}

      {/* Labels */}
      {ys.map((y, i) => {
        return (
          <text key={y} className="translate-y-0.5 select-none" x={0} y={y} fontSize="12" fill="#aaa">
            {tickFormatter(ticks[i])}
          </text>
        )
      })}
    </g>
  )
}
